import { ProductMainGroups } from '../products-matrix/product-main-groups.enum';
import { CaseImageModel } from './case-image.model';

/**
 * DTO used to send the line/product infor while Case creation, updation, and validation
 */
export class CaseLineDto {
  public id?: string;
  public productFabricSize: string;
  public productGroupId: string;
  public productGroupName: string;
  public productId: string;
  public productImageUrl: string;
  public productMainGroup: ProductMainGroups;
  public productName: string;
  public productNumber: string;
  public quantity?: number;

  // for warranty type
  public distanceRun?: string;
  public defectReason?: string;
  public comments?: string;
  public customerName?: string;
  public purchaseDate?: string;
  public productCode?: string;
  public factoryCode?: string;
  public images?: CaseImageModel[];
}
